import { createContext, ReactElement, ReactNode } from "react";
import { useApplicantDataRepo } from "./specific/ApplicantDataRepo";
import { useCaseDataRepo } from "./specific/CaseDataRepo";
import { useCaseNoteDataRepo } from "./specific/CaseNoteDataRepo";
import { useCaseQueryDataRepo } from "./specific/CaseQueryDataRepo";
import { useCaseQueryResponseDataRepo } from "./specific/CaseQueryResponseDataRepo";
import { useDeveloperDataRepo } from "./specific/DeveloperDataRepo";
import { useDevelopmentDataRepo } from "./specific/DevelopmentDataRepo";
import { useLookupDataRepo } from "./specific/LookupDataRepo";
import { useMilestoneDataRepo } from "./specific/MilestoneDataRepo";
import { useMilestoneNoteDataRepo } from "./specific/MilestoneNoteDataRepo";
import { useUserDataRepo } from "./specific/UserDataRepo";

export function DataRepo({ children }: { children: ReactNode }): ReactElement {
  const { GetApplicant, GetApplicantList, CreateApplicant, UpdateApplicant } =
    useApplicantDataRepo();
  const { GetCaseAllEntities, GetCase, GetCaseList, CreateCase, UpdateCase } =
    useCaseDataRepo();
  const { GetCaseNote, GetCaseNoteList } = useCaseNoteDataRepo();
  const { GetMyCaseQueryList, GetCaseQueryList, GetCaseQuery, CreateCaseQuery, CloseCaseQuery } =
    useCaseQueryDataRepo();
  const {
    GetCaseQueryResponse,
    GetCaseQueryResponseList,
    CreateCaseQueryResponse,
  } = useCaseQueryResponseDataRepo();
  const { GetDeveloper } = useDeveloperDataRepo();
  const { GetDevelopment, GetDevelopmentList } = useDevelopmentDataRepo();
  const { GetLookup, GetLookupList } = useLookupDataRepo();
  const { GetMilestone, GetMilestoneList } = useMilestoneDataRepo();
  const { GetMilestoneNote, GetMilestoneNoteList } = useMilestoneNoteDataRepo();
  const { GetUser, ResetPassword, RequestPasswordReset } = useUserDataRepo();

  const globalDataRepo: any = {
    // Applicant
    GetApplicant: GetApplicant,
    GetApplicantList: GetApplicantList,
    CreateApplicant: CreateApplicant,
    UpdateApplicant: UpdateApplicant,

    // Case
    GetCaseAllEntities: GetCaseAllEntities,
    GetCase: GetCase,
    GetCaseList: GetCaseList,
    CreateCase: CreateCase,
    UpdateCase: UpdateCase,

    // Case Note
    GetCaseNote: GetCaseNote,
    GetCaseNoteList: GetCaseNoteList,

    // Case Query
    GetMyCaseQueryList: GetMyCaseQueryList,
    GetCaseQueryList: GetCaseQueryList,
    GetCaseQuery: GetCaseQuery,
    CreateCaseQuery: CreateCaseQuery,
    CloseCaseQuery: CloseCaseQuery,

    // Case Query Response
    GetCaseQueryResponse: GetCaseQueryResponse,
    GetCaseQueryResponseList: GetCaseQueryResponseList,
    CreateCaseQueryResponse: CreateCaseQueryResponse,

    // Developer
    GetDeveloper: GetDeveloper,

    // Development
    GetDevelopment: GetDevelopment,
    GetDevelopmentList: GetDevelopmentList,

    // Lookup
    GetLookup: GetLookup,
    GetLookupList: GetLookupList,

    // Milestone
    GetMilestone: GetMilestone,
    GetMilestoneList: GetMilestoneList,

    // Milestone Note
    GetMilestoneNote: GetMilestoneNote,
    GetMilestoneNoteList: GetMilestoneNoteList,

    // User
    GetUser: GetUser,
    ResetPassword: ResetPassword, 
    RequestPasswordReset: RequestPasswordReset
  };

  return (
    <dataRepoContext.Provider value={{ globalDataRepo }}>
      {children}
    </dataRepoContext.Provider>
  );
}

export const dataRepoContext = createContext({} as any);
